import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e002e97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-bottom":"0.4rem"} }, "Select a payment date:", -1))
const _hoisted_4 = {
  title: "Select a date for confirmed ledger tranfers",
  class: "search-with-button"
}
const _hoisted_5 = {
  class: "date-picker",
  style: {"width":"50%"}
}
const _hoisted_6 = ["disabled"]

import { computed, ref } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import RechargeInvoicePaymentItem from "@/Interfaces/Payments/RechargeInvoicePaymentItem";
import Popup from "./Popup.vue";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { confirmRechargeInvoicePayment } from "@/services/network/index"
import IConfirmRechargeInvoicePaymentRequest from "@/Interfaces/Payments/IConfirmRechargeInvoicePaymentRequest";
import { authService } from "@/auth/authSingleton";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import { MarketCurrency, MonetaryValueWithCommas } from '@/services/helpers/Helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'RechargeInvoicePaymentPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const selectedRow = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const selectedDate = ref<Date>();
const textInputOptions = { format: "yyyy/MM/dd" };
const working = ref(false);

const emits = __emit;
function closeChild(){
    selectedDate.value = undefined;
    selectedRow.value = undefined;
}
async function ConfirmLedgerTransfer() {
    if (working.value) return;
    working.value = true;
    const closeSpinner = useSpinnerPopup().show();
    try{
        if (!selectedRow.value) throw new ReferenceError('selectedRow cannot be null when submitting the form');
        const payload: IConfirmRechargeInvoicePaymentRequest = Object.assign(selectedRow.value,{
            userEmail: authService.getEmailAddress(),
            balanceDateUpdated: new DateIgnoreTime(selectedDate.value),
            amountPaid: selectedRow.value.balance,
        });
        const response = await confirmRechargeInvoicePayment.put(payload);
        useNotifierWithErrFormatter().success({ msg: "Payment successfully registered." });
        closeChild();
        emits("confirm");
    }catch (error) {
        useNotifierWithErrFormatter().error({
            name: `${__filename}/${ConfirmLedgerTransfer.name}`,
            errorType: 'Confirming payment',
            error
        });
    } finally {
        closeSpinner();
        working.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": !!selectedRow.value,
    title: "Payment confirmation",
    hasClose: "",
    "onUpdate:modelValue": closeChild
  }, _createSlots({ _: 2 }, [
    (selectedRow.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createTextVNode(" The total amount to pay on this recharge invoice is: "),
              _createElementVNode("strong", null, _toDisplayString(_unref(MarketCurrency)[selectedRow.value.market]) + " " + _toDisplayString(_unref(MonetaryValueWithCommas)(selectedRow.value.balance)), 1)
            ]),
            _createElementVNode("form", {
              class: "top-content",
              onSubmit: _withModifiers(ConfirmLedgerTransfer, ["prevent"])
            }, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(DatePicker), {
                    modelValue: selectedDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                    type: "date",
                    "enable-time-picker": false,
                    placeholder: "Select Date...",
                    "text-input-options": textInputOptions,
                    "text-input": "",
                    "max-date": new Date(),
                    teleport: true,
                    required: ""
                  }, null, 8, ["modelValue", "max-date"])
                ]),
                _createElementVNode("button", {
                  disabled: working.value,
                  class: "right-button"
                }, "Confirm", 8, _hoisted_6)
              ])
            ], 40, _hoisted_2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["model-value"]))
}
}

})